export const REQUEST_GENERATE_SUMMARY_DATA = 'REQUEST_GENERATE_SUMMARY_DATA';
export const GENERATE_SUMMARY_DATA_RECEIVED = 'GENERATE_SUMMARY_DATA_RECEIVED';
export const REQUEST_AI_LOGS = 'REQUEST_AI_LOGS';
export const AI_LOGS_RECEIVED = 'AI_LOGS_RECEIVED';

